import { createAction } from 'redux-actions'
import axios from 'axios';

// 获取经销商信息
export const getCustomerSucceeded = createAction('customer/GET_SUCCEEDED')
export const getCustomerFailed = createAction('customer/GET_FAILED')

export function fetchCustomerNameList(params) {
  return dispatch => (
    axios.get('/api/find/customer-name', { params })
    .then(response => dispatch(getCustomerSucceeded(response)))
    .catch(error => dispatch(getCustomerFailed(error)))
  )
}

export const addCustomerSucceeded = createAction('customer/GET_SUCCEEDED')
export const addCustomerFailed = createAction('customer/GET_FAILED')

export function fetchAddCustomer(params) {
  return dispatch => (
    axios.post('/api/add/customer', params)
    .then(response => dispatch(addCustomerSucceeded(response)))
    .catch(error => dispatch(addCustomerFailed(error)))
  )
}



// WEBPACK FOOTER //
// ./actions/customer.js